import { MutationArg } from '../types';

import { api } from './base';

import { MasterKeyModel } from 'v2/types/MasterKeyModel';

export const authService = {
  checkAuth(): Promise<MasterKeyModel> {
    return api.post('admin/auth/key/token').json();
  },

  login(_key: string, { arg: key }: MutationArg<string>): Promise<MasterKeyModel> {
    return api.post('admin/auth/key/login', { json: { key } }).json();
  },

  logout(): Promise<void> {
    return api.post('admin/auth/logout').json();
  },
};
